
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, Home, Shield, Eye } from 'lucide-react';

const ServicesOverview = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge variant="outline" className="mb-4">🧰 Complete Solutions</Badge>
          <h2 className="text-3xl font-bold mb-4">Complete Roofing Services We Provide</h2>
          <p className="text-gray-600">
            We specialize in a full suite of roofing services for homes, multi-family buildings, businesses, and specialty structures throughout Eastern and Central North Carolina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <Card className="text-center hover:shadow-lg transition-shadow">
            <CardHeader>
              <Building2 className="h-12 w-12 text-primary mx-auto mb-4" />
              <CardTitle className="text-lg">Commercial Roofing</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-gray-600">Flat and low-slope expertise, built to code</p>
            </CardContent>
          </Card>

          <Card className="text-center hover:shadow-lg transition-shadow">
            <CardHeader>
              <Home className="h-12 w-12 text-primary mx-auto mb-4" />
              <CardTitle className="text-lg">Residential Roofing</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-gray-600">Weather-resistant systems, energy-conscious installation</p>
            </CardContent>
          </Card>

          <Card className="text-center hover:shadow-lg transition-shadow">
            <CardHeader>
              <Shield className="h-12 w-12 text-primary mx-auto mb-4" />
              <CardTitle className="text-lg">Storm Damage</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-gray-600">Rapid response, insurance support, storm-hardened repairs</p>
            </CardContent>
          </Card>

          <Card className="text-center hover:shadow-lg transition-shadow">
            <CardHeader>
              <Eye className="h-12 w-12 text-primary mx-auto mb-4" />
              <CardTitle className="text-lg">Technology & Inspection</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-gray-600">Modern diagnostics, safer evaluations, data-backed decisions</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
